import Constrants from "../constrants/constrant";

// Generic GET helper
const fetchData = async (endpoint, options = {}) => {
  try {
    const response = await Constrants.get(endpoint);
    const { isArray = false, nestedData = false } = options;

    let data = nestedData ? response.data.data : response.data;

    if (isArray && !Array.isArray(data)) return [];
    return data || [];
  } catch (error) {
    console.error(`Error fetching from ${endpoint}:`, error);
    throw error;
  }
};

// Category APIs
export const fetchCategories = () => fetchData("/home-categories", { nestedData: true });
export const fetchAllCategories = () => fetchData("/categories", { isArray: true, nestedData: true });
export const fetchCategoryBySlug = (slug) => fetchData(`/categories/${slug}`);
export const fetchAppsCategories = (slug) => fetchData(`/apps/categories`, { isArray: true, nestedData: true });
